// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"910":"a4634e51","912":"d279225f"}[chunkId] + "." + {"910":"3f88518f5d36044b","912":"71bde9532113c9b7"}[chunkId] + ".js";
};